/* eslint-disable @typescript-eslint/no-unused-vars */
import { FC, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { UpdateOrderStatus } from "../../../../redux/features/shopifyOrders/shopifyOrdersAction";

const Status = [
  { value: "accepted", label: "Accept" },
  { value: "rejected", label: "Reject" },
];

const shippedStatus = [
  { value: "prepared", label: "Prepared" },
  { value: "shipped", label: "Shipped" },
];

// Helper to format label from value
const getLabelFromValue = (value: string) => {
  switch (value) {
    case "accepted":
      return "Accepted";
    case "rejected":
      return "Rejected";
    case "prepared":
      return "Prepared";
    case "shipped":
      return "Shipped";
    default:
      return value.charAt(0).toUpperCase() + value.slice(1);
  }
};

const StatusCell: FC<any> = ({ userObj }) => {
  const dispatch: any = useDispatch();
  const [statusOptions, setStatusOptions] = useState<any[]>([]);
  const [localStatus, setLocalStatus] = useState(userObj.status);

  useEffect(() => {
    let options: any[] = [];

    if (localStatus === "accepted" || localStatus === "prepared") {
      options = [...shippedStatus];
    } else if (localStatus === "pending") {
      options = [...Status];
    }    

    // Ensure the current status is in the options list
    if (!options.find((opt) => opt.value === localStatus)) {
      options.unshift({
        value: localStatus,
        label: getLabelFromValue(localStatus),
      });
    }

    setStatusOptions(options);
  }, [localStatus]);

  const handleChange = async (selected: any) => {
    setLocalStatus(selected.value);
    dispatch(UpdateOrderStatus({ id: userObj.id, status: selected.value }));
  };

  return (
    <Form.Group>
      <Select
        className="custom-select-box"
        value={statusOptions.find((opt) => opt.value === localStatus)}
        name="status"
        placeholder="Select status"
        onChange={handleChange}
        options={statusOptions}
      />
    </Form.Group>
  );
};

export { StatusCell };
